import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    totalPages: 0,
    organisationData: [],
    scrollLoaderButton: false,
    dataLoader: false,
    organisationBasedTabs: 'organisation-details',
    total: 0,
    availableCredits: null,
    addCreatorCredit: null,
    refreshCreatorCredit: null
}

const OrganisationSlice = createSlice({
    name: 'organisation',
    initialState,
    reducers: {
        defaultState(state, action) {
            return initialState
        },
        setOrganizationStates(state, action) {
            const { payload: { key, value } } = action
            state[key] = value;
            return state
        },
        setOrganisationObject(state, action) {
            return { ...state, ...action?.payload }
        },
        setOrganisationData(state, action) {
            state.organisationData = action?.payload?.pagination
                ? [...state.organisationData, ...action?.payload?.organisationData]
                : action?.payload?.organisationData;
            state.total = action?.payload?.total;
            state.totalPages = action?.payload?.totalPages;
            state.page = action?.payload?.page;
            state.size = action?.payload?.size;
            state.scrollLoaderButton = action?.payload?.scrollLoaderButton;
            state.dataLoader = action?.payload?.dataLoader;
        },
        setDataLoader(state, action) {
            state.dataLoader = action.payload
        },
        setCreatorAvailableCredits(state, action) {
            state.availableCredits = action.payload?.availableCredits
            state.addCreatorCredit = action.payload?.addCreatorCredit
            state.refreshCreatorCredit = action.payload?.refreshCreatorCredit
        }
    }
})

export const OrganisationActions = OrganisationSlice.actions;
export default OrganisationSlice;
